import Cookies from 'js-cookie'

export const isLogged = () => {
  return !!Cookies.get('anm22-w-l')
}
